import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Root from "./root";
import { BASE_SITE, CHECK_LOGIN_GET } from '../apis';
import { handleSetOpenCustomSnackbar } from '../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../redux/actions/loaders';
import { handleChangeProfileData, handleChangeToken, actionLogOutUser } from '../redux/actions/pages/user/login';


const App = () => {
	
	const dispatch = useDispatch();

	const { token } = useSelector((state: any) => state.login);


	const userAgent = navigator.userAgent;
	let browser = 'Unknown';

	if (userAgent.includes('Firefox')) {
	  	browser = 'Firefox';
	} else if (userAgent.includes('Chrome')) {
	  	browser = 'Chrome';
	} else if (userAgent.includes('Safari')) {
	  	browser = 'Safari';
	} else if (userAgent.includes('Edge')) {
	  	browser = 'Edge';
	} else if (userAgent.includes('Opera')) {
	  	browser = 'Opera';
	} else if (userAgent.includes('MSIE')) {
	  	browser = 'Internet Explorer';
	}

	const deviceInfo = JSON.stringify({
	  	app_version: process.env.REACT_APP_VERSION, // یا نسخه ای که خودتان تعریف می‌کنید
	  	languages: navigator.languages || [navigator.language],
	  	plugins: Array.from(navigator.plugins).map(plugin => plugin.name),
	  	userAgent: navigator.userAgent,
	  	cpuCores: navigator.hardwareConcurrency,
	  	deviceMemory: (navigator as any).deviceMemory,
	  	timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	  	touchSupport: 'ontouchstart' in window,
	  	doNotTrack: navigator.doNotTrack,
	  	cookieEnabled: navigator.cookieEnabled,
	  	online: navigator.onLine
	});


	useEffect(() => {
        handleCheckedLoginAndOtherData();
        // eslint-disable-next-line
    }, [App]);


    const handleCheckedLoginAndOtherData = () => {

    	if(token) {
    		dispatch(handleSetBackdropLoading(true));
    		
    		axios({
	            method: 'post',
	            url: BASE_SITE + CHECK_LOGIN_GET,
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'application/x-www-form-urlencoded',
	                'Authorization': token,
	            },
	            data: { 
			    	width: window.screen.width, 
			    	height: window.screen.height, 
			    	platform: navigator.platform,
			    	browser,
			    	deviceInfo
			    },
	        }).then((response) => {
	            switch (response.data.status) {
	                case 'error':
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
	                    break;
                    case 're_login':
	                	dispatch(actionLogOutUser());
	                    break;
	                case 'ok':
	                    dispatch(handleChangeProfileData(response.data.info));
	                    break;
	                default:
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
	            }
	            dispatch(handleSetBackdropLoading(false));
	        }, () => {
	            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
	            dispatch(handleSetBackdropLoading(false));
	        });   		
    	}
    };

	return (
        <div id={'app'} className={'rtl'}>
            <Root/>
        </div>
    )
}

export default memo(App);
